// Web-only strings for calls (keys prefixed `web.call.`), BOTH languages. The Apple `call.*` keys are
// used wherever they exist; these are the microphone cases the apps never needed to tell apart
// (core/callMicrophone.ts): a device with NO microphone joins listening only, and a microphone that
// exists but cannot be opened is not a missing permission.
export const strings: { es: Record<string, string>; en: Record<string, string> } = {
  es: {
    'web.call.notice.noMicrophone': 'No hay ningún micrófono conectado: entraste a la llamada solo para escuchar. Conecta uno y pulsa «Activar micro» para hablar.',
    'web.call.notice.micUnavailable': 'No se pudo abrir el micrófono. Puede que otra aplicación lo esté usando o que el sistema lo tenga bloqueado.',
    'web.call.noMicrophone': 'No hay micrófono — pulsa para volver a intentarlo',
    // «Invitar» (shared/API.md §30.3).
    'web.call.invite': 'Invitar',
    'web.call.invite.help': 'Invitar a otras personas a la llamada',
    'web.call.invite.title': 'Invitar a la llamada',
    'web.call.invite.pickHint': 'Elige a quién invitar.',
    'web.call.invite.hintRing': 'Les sonará la llamada.',
    'web.call.invite.hintMove': 'La llamada pasará a un grupo con todos.',
    'web.call.invite.send': 'Invitar',
    'web.call.invite.sending': 'Invitando…',
    'web.call.invite.sent': 'Invitación enviada a %@',
    'web.call.invite.sendFailed': 'No se pudo invitar a %@',
    'web.call.invite.addFailed': 'No se pudo agregar a %@ al canal',
    'web.call.invite.notAllowed': 'No tienes permiso para agregar a %@ al canal',
    'web.call.invite.moved': 'La llamada continúa en el grupo con %@',
    'web.call.invite.moveFailed': 'No se pudo pasar la llamada a un grupo',
    'web.call.invite.tooMany': 'Una llamada de grupo admite hasta %d personas',
    'web.call.invite.row': '%1$@ te invitó a una llamada en %2$@',
    'web.call.invite.rowNoTitle': '%@ te invitó a una llamada',
    'web.call.invite.rowSent': 'Enviaste una invitación a la llamada en %@',
    'web.call.invite.rowSentNoTitle': 'Enviaste una invitación a una llamada',
    'web.call.invite.movedRow': 'La llamada continuó en el grupo con %@',
    'web.call.invite.movedRowNoNames': 'La llamada continuó en un grupo',
    'web.call.invite.join': 'Unirse',
    'web.call.invite.inCall': 'Estás en la llamada',
    'web.call.invite.ended': 'La llamada terminó',
    'web.call.invite.from': '%@ te invita a una llamada',
  },
  en: {
    'web.call.notice.noMicrophone': 'No microphone is connected: you joined the call to listen only. Connect one and press «Unmute» to talk.',
    'web.call.notice.micUnavailable': "The microphone couldn't be opened. Another app may be using it, or the system may be blocking it.",
    'web.call.noMicrophone': 'No microphone — click to try again',
    'web.call.invite': 'Invite',
    'web.call.invite.help': 'Invite other people to the call',
    'web.call.invite.title': 'Invite to the call',
    'web.call.invite.pickHint': 'Choose who to invite.',
    'web.call.invite.hintRing': 'Their phone will ring.',
    'web.call.invite.hintMove': 'The call will move to a group with everyone.',
    'web.call.invite.send': 'Invite',
    'web.call.invite.sending': 'Inviting…',
    'web.call.invite.sent': 'Invitation sent to %@',
    'web.call.invite.sendFailed': "Couldn't invite %@",
    'web.call.invite.addFailed': "Couldn't add %@ to the channel",
    'web.call.invite.notAllowed': "You don't have permission to add %@ to the channel",
    'web.call.invite.moved': 'The call continues in the group with %@',
    'web.call.invite.moveFailed': "Couldn't move the call to a group",
    'web.call.invite.tooMany': 'A group call allows up to %d people',
    'web.call.invite.row': '%1$@ invited you to a call in %2$@',
    'web.call.invite.rowNoTitle': '%@ invited you to a call',
    'web.call.invite.rowSent': 'You sent an invitation to the call in %@',
    'web.call.invite.rowSentNoTitle': 'You sent an invitation to a call',
    'web.call.invite.movedRow': 'The call continued in the group with %@',
    'web.call.invite.movedRowNoNames': 'The call continued in a group',
    'web.call.invite.join': 'Join',
    'web.call.invite.inCall': "You're on the call",
    'web.call.invite.ended': 'The call ended',
    'web.call.invite.from': '%@ is inviting you to a call',
  },
};
